<script>
    import {_, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";
    import allianceShieldFrame from '../../assets/support_items_frame.png?format=webp;jpg';

    let { item, gameItem, globals } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        itemDetails.title = $_(gameItem.category + gameItem.seconds + 'SecondsTitle');
        itemDetails.description = $_(gameItem.category + gameItem.seconds + 'SecondsDescription');
        itemDetails.icon = 'peaceShield';
        itemDetails.frameImage = allianceShieldFrame;
        itemDetails.amount = item.amount;
        itemDetails.rarity = gameItem.rarity;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
